import React, { createContext, useContext, useState } from "react";

const ScrollContext = createContext({
  currentSection: "home",
  setCurrentSection: () => {},
  scrollToSection: () => {},
  scrollProgress: 0,
  setScrollProgress: () => {},
});

export const useScrollContext = () => {
  const context = useContext(ScrollContext);
  if (!context) {
    throw new Error("useScrollContext must be used within a ScrollProvider");
  }
  return context;
};

export const ScrollProvider = ({ children }) => {
  const [currentSection, setCurrentSection] = useState("home");
  const [scrollProgress, setScrollProgress] = useState(0);

  // Function to jump to a specific section instantly
  const scrollToSection = (section) => {
    // Trigger instant jump to section
    // Using timestamp to ensure event is always fresh
    const event = new CustomEvent("scrollToSection", {
      detail: {
        section,
        timestamp: Date.now(),
        instant: true, // Flag to indicate this should be an instant jump
      },
    });
    window.dispatchEvent(event);
  };

  const value = {
    currentSection,
    setCurrentSection,
    scrollToSection,
    scrollProgress,
    setScrollProgress,
  };

  return (
    <ScrollContext.Provider value={value}>{children}</ScrollContext.Provider>
  );
};

export default ScrollContext;
